import { Col, Form, Row, Table } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { OnboardingStepProps, userTableColumns } from "..";
import { DATE_UTIL } from "../../../../utils/dateUtils";


export default function ReivewData(props: OnboardingStepProps) {

    const { t } = useTranslation();

    const columns = userTableColumns;


    return (

        <React.Fragment>
            <div className='form-section'>
                <p className='section-title'>
                    {t("Onboarding.ttCorporateInformation")}
                </p>

                <Form.Item
                    label={t("Onboarding.lbNextYearEndDate")}
                >
                    {DATE_UTIL.convertServerToViewFormat(props.model?.next_year_end_date?.toString())}
                </Form.Item>

                <Form.Item
                    label={t("Onboarding.lbYearEndReminderPeriod")}
                    name="year_end_reminder_period"
                >
                    <span>
                        {props.model?.year_end_reminder_period} {props.model?.year_end_reminder_period && props.model?.year_end_reminder_period > 1 ? "days" : "day"}
                    </span>
                </Form.Item>

                <Form.Item
                    label={t("Onboarding.lbNextQuarterEndDate")}
                >
                    {DATE_UTIL.convertServerToViewFormat(props.model?.next_quarter_end_date?.toString())}
                </Form.Item>

                <Form.Item
                    label={t("Onboarding.lbQuarterEndReminderPeriod")}
                >
                    <span>
                        {props.model?.quarter_end_reminder_period} {props.model?.quarter_end_reminder_period && props.model?.quarter_end_reminder_period > 1 ? "days" : "day"}
                    </span>
                </Form.Item>
            </div>
            <div className='form-section'>
                <p className='section-title'>
                    {t("Onboarding.ttAddUsers")}
                </p>
                <div className="section-wrapper">
                    <div className="table-wrapper">
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Table
                                    dataSource={props.users}
                                    columns={columns}
                                    rowKey="email" />
                            </Col>
                        </Row>
                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}
